import { useTranslation } from 'react-i18next';
import { useGet } from '@/query/fetchHooks';
import { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, IconTile, ProgressBar, TEOLoader } from '@teo/components';
import {
  Theme,
  ArrowLeft,
  TimeFilled,
  Shapes,
  Training,
  Evaluation,
  DuoToneCourseFilled,
  DuoToneAssessmentFilled,
  DuoToneVacancyFilled,
  TaskCheckmarkFilled,
  PlayFilled,
  InformationFilled,
  CloseCircleFilled,
  DuoToneCompetenceFilled,
} from '@teo/components/icons';
import { Blocked } from '@/components/Images/Blocked';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { nthLastIndexOf, convertToTime } from '@/util';
import {
  sortDataLP,
  categoriesIcon,
  applyCompetenceSkips,
} from '@/components/LearningPath/util';
import { axios } from '@/axios';
import { config } from '@/config';
import { NavContext } from '@/components/NavContext';

const ThemeIcon = ({ allCategories, theme }: any) => {
  let Icon;
  if (theme?.tags) {
    const learningpathTags = allCategories?.find(
      (el: any) => el?.label === theme?.tags.split(':')[1]
    );
    Icon = categoriesIcon(learningpathTags?.icon);
  } else {
    Icon = Theme;
  }
  return <IconTile Icon={Icon} color={'dark_blue'} size="small_lg" />;
};

function Themes() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const { setHeaderDisabled } = useContext(NavContext);
  const { themeId, lpgroupId, organisationId } = useParams();
  const [theme, setTheme] = useState<any>(null);
  const [nodes, setNodes] = useState<any>(null);
  const [themeProgress, setThemeProgress] = useState<any>(0);
  const [currentNode, setCurrentNode] = useState<any>(null);
  const [allCategories, setAllCategories] = useState([]);

  const originPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 2)
  );

  const parentPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 4)
  );

  useEffect(() => {
    setHeaderDisabled(true);
    return () => setHeaderDisabled(false);
  });

  useGet(`/categories`, {
    sort: 'tag',
    organisationId: `${auth?.user?.activeOrganisationId},OR,organisationId=null`,
    onSuccess: (result: any) => {
      setAllCategories(
        result?.data?.map((el: any) => ({
          id: el.id,
          label: el.tag,
          icon: el.icon,
        })) || []
      );
    },
  });

  useGet(`/learningpath/${themeId}`, {
    onSuccess: async (res: any) => {
      setTheme(res?.data || {});
    },
  });

  useGet(`/lpnodestatuses`, {
    lpgroupId,
    learningpathId: themeId,
    userId: auth?.user?.id,
    onSuccess: async (res: any) => {
      const nodedetails = applyCompetenceSkips(
        (res?.data || []).filter((el: any) => el?.type !== 'root')
      );
      const sortData = sortDataLP(nodedetails);
      let allprogress = 0;
      let isCurrentNode = false;
      let activeNode = null;
      for (const nds of sortData) {
        const progress = nds?.progress ?? 0;
        allprogress = allprogress + (nds?.skippedByCompetences ? 1 : progress);
        if (0 < progress && progress < 1) {
          setCurrentNode(nds);
          activeNode = nds;
        }
        if (
          !activeNode &&
          !isCurrentNode &&
          progress !== 1 &&
          !nds?.skippedByCompetences
        ) {
          setCurrentNode(nds);
          activeNode = nds;
          isCurrentNode = true;
        }
      }

      setThemeProgress(sortData?.length ? allprogress / sortData.length : 0);
      setNodes(sortData);
      // const nodedetails = res?.data?.filter(
      //   (el: any) => el?.type !== 'root' && el?.learningpathId == themeId
      // );
      // if (nodedetails?.length > 0) {
      //   const sortData = sortDataLP(nodedetails);
      //   setNodes2(sortData);
      // }
    },
  });

  // useGet(`/learningpathnodedetails`, {
  //   learningpathId: themeId,
  //   organisationId: organisationId,
  //   onSuccess: async (res: any) => {
  //     const nodedetails = (res?.data || []).filter(
  //       (el: any) => el?.type !== 'root'
  //     );
  //     const newNodedetails: any[] = [];
  //     let allprogress = 0;
  //     let isCurrentNode = false;
  //     for (const nds of nodedetails) {
  //       let nodeFollow = null;

  //       try {
  //         if (nds?.type === 'course') {
  //           nodeFollow = await axios.get(
  //             `${config.backend}/student/${nds?.objectId}/${auth?.user?.id}`
  //           );
  //         } else if (nds?.type === 'training') {
  //           nodeFollow = await axios.get(
  //             `${config.backend}/trainingfollow/${nds?.objectId}/${auth?.user?.id}`
  //           );
  //         }

  //         const progress = nodeFollow?.data?.progress ?? 0;
  //         const status = nodeFollow?.data?.status ?? null;
  //         allprogress = allprogress + progress;

  //         if (0 < progress && progress < 1) {
  //           setCurrentNode({ ...nds, progress, status, isFollow: true });
  //         }

  //         newNodedetails.push({ ...nds, progress, status, isFollow: true });
  //       } catch (e) {
  //         if (!currentNode && !isCurrentNode) {
  //           setCurrentNode({
  //             ...nds,
  //             progress: 0,
  //             status: null,
  //             isFollow: false,
  //           });
  //           isCurrentNode = true;
  //         }
  //         newNodedetails.push({
  //           ...nds,
  //           progress: 0,
  //           status: null,
  //           isFollow: false,
  //         });
  //       }
  //     }
  //     setThemeProgress(allprogress / newNodedetails?.length);
  //     const sortData = sortDataLP(newNodedetails);
  //     setNodes(sortData);
  //   },
  // });

  return (
    <div className="flex w-full flex-col ">
      {!theme || !nodes ? (
        <div className="fixed inset-0 z-[101] flex bg-white/75">
          <div className="m-auto">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[120px]"
            />
          </div>
        </div>
      ) : (
        <div className="flex w-full flex-col lg:flex-row">
          <div className="mx-auto w-full max-w-3xl flex-col">
            {auth && (
              <Button
                className="flex items-center gap-3"
                variant="text"
                onClick={() => navigate(`${originPath}`)}
              >
                <ArrowLeft className="h-5 w-5" />
                <p>{t('pages.lp_landing.back_to_lpgroup')}</p>
              </Button>
            )}
            <div className="-ml-4 -mr-4 flex w-full flex-col md:ml-0 md:mr-0">
              <div className="flex w-full flex-col border-b px-4 pb-8 md:px-0">
                <div className="flex pt-4">
                  <ThemeIcon allCategories={allCategories} theme={theme} />
                </div>
                <div className="flex flex-col pt-4">
                  <p className="text-sm text-grey-05">
                    {t('pages.landing_training.theme')}
                  </p>
                  <p className={`pt-1 pb-4 text-xl font-semibold text-black`}>
                    {theme?.lpName}
                  </p>

                  <div className="my-4 flex items-center">
                    <div className="flex w-full">
                      <ProgressBar
                        max={100}
                        value={Math.round(themeProgress * 100)}
                        className={`h-1 overflow-hidden rounded-lg ${
                          themeProgress * 100 > 99 && 'progress-bar__all'
                        }`}
                      />
                    </div>
                    <span className="pl-3 text-xs text-grey-06">
                      {Math.round(themeProgress * 100)}%
                    </span>
                  </div>
                  <p className={`text-base text-grey-08  `}>
                    {theme?.lpDescription}
                  </p>

                  <div className="mt-4 flex gap-4">
                    {nodes?.length > 0 && (
                      <div className="flex items-center">
                        <Shapes className="h-4 w-4 text-grey-04" />
                        <p className="pl-1 text-sm text-grey-05">
                          {nodes?.length} {t('pages.lp_landing.items')}
                        </p>
                      </div>
                    )}

                    {/*theme?.lpEstimatedTime > 0 && (
                      <div className="flex items-center">
                        <TimeFilled className="h-4 w-4 text-grey-04" />
                        <p className="pl-1 text-sm text-grey-05">
                          {convertToTime(
                            Math.abs(theme?.lpEstimatedTime),
                            t('pages.learn_index.hour'),
                            t('pages.learn_index.minute')
                          )}
                        </p>
                      </div>
                    )*/}
                  </div>
                </div>
                {currentNode && (
                  <div className="mt-8">
                    {themeProgress > 0 ? (
                      <Button
                        onClick={() => {
                          const node = currentNode;
                          if (node?.type === 'course') {
                            if (node?.status == 'not_started') {
                              const promises = [];
                              promises.push(
                                axios.post(`${config.backend}/follows`, {
                                  courseId: node?.objectId,
                                  userId: auth?.user?.id,
                                  role: 20,
                                })
                              );
                              Promise.allSettled(promises).then(() => {
                                navigate(
                                  `${parentPath}/${
                                    node?.subType === 'assessment'
                                      ? 'assessments'
                                      : node?.subType === 'assessment'
                                      ? 'vacancies'
                                      : 'courses'
                                  }/${node?.objectId}`
                                );
                              });
                            } else {
                              navigate(
                                `${parentPath}/${
                                  node?.subType === 'assessment'
                                    ? 'assessments'
                                    : node?.subType === 'assessment'
                                    ? 'vacancies'
                                    : 'courses'
                                }/${node?.objectId}`
                              );
                            }
                          }

                          if (node?.type === 'training') {
                            if (node?.status == 'not_started') {
                              const promises = [];
                              promises.push(
                                axios.post(
                                  `${config.backend}/trainingfollows`,
                                  {
                                    trainingId: node?.objectId,
                                    userId: auth?.user?.id,
                                  }
                                )
                              );
                              Promise.allSettled(promises).then(() => {
                                navigate(
                                  `${originPath}/${
                                    node?.subType === 'milestone'
                                      ? 'milestones'
                                      : node?.subType === 'evaluation'
                                      ? 'evaluations'
                                      : 'trainings'
                                  }/${node?.objectId}`
                                );
                              });
                            } else {
                              navigate(
                                `${originPath}/${
                                  node?.subType === 'milestone'
                                    ? 'milestones'
                                    : node?.subType === 'evaluation'
                                    ? 'evaluations'
                                    : 'trainings'
                                }/${node?.objectId}`
                              );
                            }
                          }
                        }}
                      >
                        {t('pages.lp_landing.btn_resume')}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          const node = nodes[0];
                          if (node?.type === 'course') {
                            if (!node?.isFollow) {
                              const promises = [];
                              promises.push(
                                axios.post(`${config.backend}/follows`, {
                                  courseId: node?.objectId,
                                  userId: auth?.user?.id,
                                  role: 20,
                                })
                              );
                              Promise.allSettled(promises).then(() => {
                                navigate(
                                  `${parentPath}/${
                                    node?.subType === 'assessment'
                                      ? 'assessments'
                                      : node?.subType === 'assessment'
                                      ? 'vacancies'
                                      : 'courses'
                                  }/${node?.objectId}`
                                );
                              });
                            } else {
                              navigate(
                                `${parentPath}/${
                                  node?.subType === 'assessment'
                                    ? 'assessments'
                                    : node?.subType === 'assessment'
                                    ? 'vacancies'
                                    : 'courses'
                                }/${node?.objectId}`
                              );
                            }
                          }

                          if (node?.type === 'training') {
                            if (!node?.isFollow) {
                              const promises = [];
                              promises.push(
                                axios.post(
                                  `${config.backend}/trainingfollows`,
                                  {
                                    trainingId: node?.objectId,
                                    userId: auth?.user?.id,
                                  }
                                )
                              );
                              Promise.allSettled(promises).then(() => {
                                navigate(
                                  `${originPath}/${
                                    node?.subType === 'milestone'
                                      ? 'milestones'
                                      : node?.subType === 'evaluation'
                                      ? 'evaluations'
                                      : 'trainings'
                                  }/${node?.objectId}`
                                );
                              });
                            } else {
                              navigate(
                                `${originPath}/${
                                  node?.subType === 'milestone'
                                    ? 'milestones'
                                    : node?.subType === 'evaluation'
                                    ? 'evaluations'
                                    : 'trainings'
                                }/${node?.objectId}`
                              );
                            }
                          }
                        }}
                      >
                        {t('pages.lp_landing.btn_start')}
                      </Button>
                    )}
                  </div>
                )}
              </div>
              <div className="my-8 flex w-full flex-col px-4 md:px-0">
                <p className={`mb-3 text-base font-medium `}>
                  {t('pages.course_landing.contents')}
                </p>
                <div className="flex flex-col gap-3">
                  {nodes?.map((node: any, index: number) => {
                    const prevDone =
                      index === 0 ||
                      nodes[index - 1]?.progress > 0.98 ||
                      !!nodes[index - 1]?.skippedByCompetences;
                    const skippedIcon = (
                      <div
                        className="m-2 flex h-6 w-6 rounded-[4px] bg-secondary-04"
                        title={t('pages.learning_path.conditions.skip_badge')}
                      >
                        <DuoToneCompetenceFilled className="m-auto w-4 fill-white text-white" />
                      </div>
                    );
                    const hasScore =
                      node.maxScore === 0 &&
                      node.score === 0 &&
                      node?.isCorrected
                        ? true
                        : node.minScore > 0
                        ? node.score / node.maxScore >= node?.minScore
                        : true;
                    return (
                      <div
                        key={node?.id}
                        className={`flex w-full items-center rounded-lg pr-2 ${
                          (prevDone || theme?.order !== 'fixed') &&
                          'hover:cursor-pointer hover:bg-grey-01'
                        }`}
                        onClick={() => {
                          if (prevDone || theme?.order !== 'fixed') {
                            if (node?.type === 'course') {
                              if (node?.status == 'not_started') {
                                const promises = [];
                                promises.push(
                                  axios.post(`${config.backend}/follows`, {
                                    courseId: node?.objectId,
                                    userId: auth?.user?.id,
                                    role: 20,
                                  })
                                );
                                Promise.allSettled(promises).then(() => {
                                  navigate(
                                    `${parentPath}/${
                                      node?.subType === 'assessment'
                                        ? 'assessments'
                                        : node?.subType === 'assessment'
                                        ? 'vacancies'
                                        : 'courses'
                                    }/${node?.objectId}`
                                  );
                                });
                              } else {
                                navigate(
                                  `${parentPath}/${
                                    node?.subType === 'assessment'
                                      ? 'assessments'
                                      : node?.subType === 'assessment'
                                      ? 'vacancies'
                                      : 'courses'
                                  }/${node?.objectId}`
                                );
                              }
                            }

                            if (node?.type === 'training') {
                              if (node?.status == 'not_started') {
                                const promises = [];
                                promises.push(
                                  axios.post(
                                    `${config.backend}/trainingfollows`,
                                    {
                                      trainingId: node?.objectId,
                                      userId: auth?.user?.id,
                                    }
                                  )
                                );
                                Promise.allSettled(promises).then(() => {
                                  navigate(
                                    `${originPath}/${
                                      node?.subType === 'milestone'
                                        ? 'milestones'
                                        : node?.subType === 'evaluation'
                                        ? 'evaluations'
                                        : 'trainings'
                                    }/${node?.objectId}`
                                  );
                                });
                              } else {
                                navigate(
                                  `${originPath}/${
                                    node?.subType === 'milestone'
                                      ? 'milestones'
                                      : node?.subType === 'evaluation'
                                      ? 'evaluations'
                                      : 'trainings'
                                  }/${node?.objectId}`
                                );
                              }
                            }
                          }
                        }}
                      >
                        <IconTile
                          Icon={
                            node.subType === 'training'
                              ? Training
                              : node.subType === 'evaluation'
                              ? Evaluation
                              : node.subType === 'course'
                              ? DuoToneCourseFilled
                              : node.subType === 'assessment'
                              ? DuoToneAssessmentFilled
                              : node.subType === 'leervacature'
                              ? DuoToneVacancyFilled
                              : DuoToneCourseFilled
                          }
                          imageUrl={node.picture}
                          color={
                            node.subType === 'training'
                              ? 'green'
                              : node.subType === 'evaluation'
                              ? 'purple'
                              : node.subType === 'course'
                              ? 'yellow'
                              : node.subType === 'assessment'
                              ? 'red'
                              : node.subType === 'leervacature'
                              ? 'yellow'
                              : 'yellow'
                          }
                          size="small_lg"
                          className={
                            node.subType === 'course' ||
                            node.subType === 'import'
                              ? 'fill-primary-06 text-primary-01'
                              : node.subType === 'assessment'
                              ? 'fill-tint-red-dark text-tint-red-light'
                              : node.subType === 'leervacature'
                              ? 'fill-error-04 text-error-04'
                              : ''
                          }
                        />
                        <div className="mx-4 flex flex-col">
                          <h4>
                            {index + 1}. {node?.name}
                          </h4>
                          <p className="mt-1 text-sm text-grey-04">
                            {node.subType === 'training'
                              ? t('pages.learning_path.training')
                              : node.subType === 'evaluation'
                              ? t('pages.learning_path.evaluation')
                              : node.subType === 'course'
                              ? t('links.course')
                              : node.subType === 'assessment'
                              ? t('links.assessment')
                              : node.subType === 'leervacature'
                              ? t('links.vacancy')
                              : t('links.course')}
                          </p>
                        </div>
                        <div className="ml-auto">
                          {theme?.order === 'fixed' ? (
                            <>
                              {node?.progress >= 0.99 ? (
                                <>
                                  {node?.isCorrected ? (
                                    hasScore ? (
                                      <TaskCheckmarkFilled className="m-2 w-6 text-success-05" />
                                    ) : (
                                      <CloseCircleFilled className="m-2 w-6 text-error-04" />
                                    )
                                  ) : (
                                    <InformationFilled className="m-2 w-6 text-secondary-04" />
                                  )}
                                </>
                              ) : node?.progress > 0 ? (
                                <div
                                  className="relative h-8 min-h-8 w-8 min-w-8 rounded-full text-center sm:h-9 sm:min-h-9 sm:w-9 sm:min-w-9"
                                  style={{
                                    background: `radial-gradient(closest-side, white 85%, transparent 90% 100%),conic-gradient(#3257fc ${
                                      node?.progress
                                        ? Math.round(node.progress * 100)
                                        : 0
                                    }%, #1e1e2014 0)`,
                                  }}
                                >
                                  <p className="pt-2 text-xs text-grey-07 sm:pt-2.5">
                                    {node?.progress
                                      ? Math.round(node.progress * 100)
                                      : 0}
                                    &#37;
                                  </p>
                                </div>
                              ) : node?.skippedByCompetences && prevDone ? (
                                skippedIcon
                              ) : !prevDone ? (
                                <Blocked className="m-2 mr-3 w-4 text-grey-05" />
                              ) : (
                                <div className="relative flex h-8 min-h-8 w-8 min-w-8 rounded-full border-2 border-[#1e1e2014] pl-0.5 text-center sm:h-9 sm:min-h-9 sm:w-9 sm:min-w-9">
                                  <PlayFilled className="m-auto w-4 text-secondary-04" />
                                </div>
                              )}
                            </>
                          ) : node?.progress >= 0.99 ? (
                            <TaskCheckmarkFilled className="m-2 w-6 text-success-05" />
                          ) : node?.skippedByCompetences ? (
                            skippedIcon
                          ) : node?.progress > 0 ? (
                            <div
                              className="relative h-8 min-h-8 w-8 min-w-8 rounded-full text-center sm:h-9 sm:min-h-9 sm:w-9 sm:min-w-9"
                              style={{
                                background: `radial-gradient(closest-side, white 85%, transparent 90% 100%),conic-gradient(#3257fc ${
                                  node?.progress
                                    ? Math.round(node.progress * 100)
                                    : 0
                                }%, #1e1e2014 0)`,
                              }}
                            >
                              <p className="pt-2 text-xs text-grey-07 sm:pt-2.5">
                                {node?.progress
                                  ? Math.round(node.progress * 100)
                                  : 0}
                                &#37;
                              </p>
                            </div>
                          ) : (
                            <div className="relative flex h-8 min-h-8 w-8 min-w-8 rounded-full border-2 border-[#1e1e2014] pl-0.5 text-center sm:h-9 sm:min-h-9 sm:w-9 sm:min-w-9">
                              <PlayFilled className="m-auto w-4 text-secondary-04" />
                            </div>
                          )}
                          {/* <Blocked className="w-4 text-grey-05" /> */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Themes;
